import PESService from 'App/services/PESService';
import toast from 'Shared/toast';
import { useMutation, useQueryClient } from 'react-query';

function useDeleteWorkQueueFilterMutation() {
    const queryClient = useQueryClient();

    return useMutation((reqBody) => PESService.deleteFilter(reqBody?.uuid), {
        onSuccess: async (data, deleteFilter) => {
            toast.success('Filter has been deleted successfully.');
            await queryClient.setQueryData(
                ['workQueue', 'savedFilters', deleteFilter?.filterType],
                Object.values(data || {})
            );
        },
    });
}

export default useDeleteWorkQueueFilterMutation;
